import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesInventarios() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Existencias", items: [
      { label: "Inventario", icon: "fas fa-warehouse", color: "#06b6d4", href: "/ListadoInventarios", desc: "Existencia por area", enabled: !!user.inventarios },
      { label: "Inventario Costos", icon: "fas fa-warehouse", color: "#14b8a6", href: "/ListadoInventariosCostos", desc: "Valorizado", enabled: !!user.inventarios },
      { label: "Disponible", icon: "fas fa-tasks", color: "#3b82f6", href: "/ListadoDisponible", desc: "Disponible general", enabled: !!user.menu_disponible },
      { label: "Disponible Vendedor", icon: "fas fa-tasks", color: "#3b82f6", href: "/ListadoDisponibleVendedor", desc: "Por vendedor", enabled: !!user.disponible_vendedores },
    ]},
    { section: "Movimientos", items: [
      { label: "Traspasos Salida", icon: "fas fa-sign-out-alt", color: "#ef4444", href: "/ListadoTraspasosSalida", desc: "Salidas entre areas", enabled: !!user.menu_traspasos_salida },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt", color: "#10b981", href: "/ListadoTraspasosEntrada", desc: "Entradas entre areas", enabled: !!user.menu_traspasos_entrada },
      { label: "Ajuste Inventario", icon: "fas fa-plus", color: "#8b5cf6", href: "/ListadoAjustesInventario", desc: "Ajustes de existencia", enabled: !!user.ajustesInventario },
      { label: "Muestras Entrada", icon: "fas fa-arrow-down", color: "#10b981", href: "/ListadoMuestrasEntrada", desc: "Entrada de muestras", enabled: !!user.menu_traspasos_entrada },
      { label: "Muestras Salida", icon: "fas fa-arrow-up", color: "#f59e0b", href: "/ListadoMuestrasSalida", desc: "Salida de muestras", enabled: !!user.menu_traspasos_salida },
    ]},
    { section: "Seguimiento y Precios", items: [
      { label: "Tracking", icon: "fas fa-search", color: "#6366f1", href: "/ListadoTracking", desc: "Rastreo de modelo", enabled: !!user.seguimiento_inventarios },
      { label: "Kardex", icon: "fas fa-clipboard-list", color: "#6366f1", href: "/ListadoKardex", desc: "Movimientos por modelo", enabled: !!user.seguimiento_inventarios },
      { label: "Ultimo Precio Cliente", icon: "fas fa-dollar-sign", color: "#8b5cf6", href: "/ReporteUltimoPrecio", desc: "Precio por cliente", enabled: !!user.inventarios },
      { label: "Ultimo Precio Modelo", icon: "fas fa-dollar-sign", color: "#8b5cf6", href: "/ReporteUltimoPrecioArticulo", desc: "Precio por modelo", enabled: !!user.inventarios },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Inventarios"
      descripcion="Existencias, movimientos y seguimiento"
      icono="fas fa-warehouse"
      color="#06b6d4"
      secciones={SECCIONES}
    />
  );
}

export default BotonesInventarios;
